import { render, staticRenderFns } from "./DashExternals.vue?vue&type=template&id=0009b43c&scoped=true"
import script from "./DashExternals.vue?vue&type=script&lang=js"
export * from "./DashExternals.vue?vue&type=script&lang=js"
import style0 from "./DashExternals.vue?vue&type=style&index=0&id=0009b43c&prod&lang=css"
import style1 from "./DashExternals.vue?vue&type=style&index=1&id=0009b43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0009b43c",
  null
  
)

export default component.exports